import React, { useState, useEffect, useCallback, useRef } from "react";

import styles from "./comp.module.css";
// STYLES are in globalThis.css

import UploadIcon from "../../static/images/cloud.svg";
import SuccessGif from "../../static/images/success.gif";
import { Link } from 'react-router-dom';


import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { UPLOAD_RESUME } from "../../config";
import { useLocation, useNavigate } from "react-router-dom";
import { profileDetailsAction } from "../../redux/actions";

import Jis from "../jis";



export default function DragAndDrop(props) {

  const customLoadingBarRef = useRef(null)
  const heightRef = useRef(null)
  const [loadingBar, setLoadingBar] = useState('none')
  const UserIdReduxState = useSelector(state => state.UserIdReduxState)
  const [start, setStart] = useState(false);
  const [notScreening, setNotScreening] = useState(true);
  const [success, setSuccess] = useState(false);
  const [files, setFiles] = useState([]);
  const [extracted, setExtracted] = useState(false)
  const { t } = useTranslation()
  const fileInputRef = useRef(null)
  // const axiosRef = useRef(axios.CancelToken.source());
  const controller = new AbortController()
  const location = useLocation();
  const pathname = location.pathname;

  const dispatch = useDispatch()
  const navigate = useNavigate()

  async function startScreening() {
    console.log("========Start Screening=====")
    const utctime = new Date().toISOString()



    const formData = new FormData();
    formData.append('utc_datetime', utctime)
    files.forEach((file) => {
      formData.append("files", file);
    });
    if (!UserIdReduxState) {
      console.log("from landing page")
      formData.append("projectID", "LandingPage");
    } else {
      console.log("not from landing page")
      formData.append("projectID", UserIdReduxState);
    }

    setNotScreening(false);
    setLoadingBar('flex')
    startLoadinBar()
    console.log("uploaded data", formData.get("projectID"))
    await axios.post(UPLOAD_RESUME, formData, { withCredentials: true, signal: controller.signal })
      .then((res) => {
        console.log(res);
        setFiles([])
        setLoadingBar('none')
        setSuccess(true);

        stopLoadingBar()
        setTimeout(() => {
          if (res.data.data.length === 1) {
            dispatch(profileDetailsAction(res.data.data[0]))
            if (pathname === "/upload") {
              navigate("/jis", { state: { pdf_path: res.data.data[0].pdf_url.split("s3.amazonaws.com/")[1] } })
            }
            else {
              setExtracted(true)
            }

          }
          else {
            navigate("/screened-resume")
          }
        }, 3000)


      }).catch((err) => {
        console.log(err);
        if (axios.isCancel(err)) {
          console.log('Request canceled:', err.message);
        }
        else {
          if (err?.response?.status === 400 && err?.response?.data?.detail === "Pdf is not readable") {
            alert(t("PDF is not readable beacuse of OCR presence!!!"))
          } else if (err?.response?.status === 504) {
            alert(t("File taking more than 1min, try again or try other file"))

          }
          else {
            alert(t("Something went wrong :( try again"))
          }
        }
        // if(err.response)
        setNotScreening(true)
        setStart(false)
        setFiles([])

        stopLoadingBar()
      });

  }
  function uploadFile(file) {
    const dropArea = document.querySelector(".drop-section");
    const listSection = document.querySelector(".list-section");
    const listContainer = document.querySelector(".list");
    dropArea.classList.add("drop-section-after-upload")
    listSection.style.display = "block";
    var li = document.createElement("li");
    li.classList.add("in-prog");
    li.innerHTML = `
      <div class="col">
        <svg width="40" height="50" viewBox="0 0 40 50" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <rect width="40" height="50" fill="url(#pattern0)"/>
        <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlink:href="#image0_739_1409" transform="scale(0.025 0.02)"/>
        </pattern>
         <image id="image0_739_1409" width="40" height="50" xlink:href="data:image/png;base64,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"/>
        </defs>
        </svg>        
      </div>
      <div class="col">
          <div class="file-name">
              <div class="name">${file.name}</div>
              <span>0%</span>
          </div>
          <div class="file-progress">
              <span></span>
          </div>
          <div class="file-size">${(file.size / (1024 * 1024)).toFixed(
      2
    )} MB</div>
      </div>
      <div class="col">
          <svg xmlns="http://www.w3.org/2000/svg" class="cross" height="20" width="20"><path d="m5.979 14.917-.854-.896 4-4.021-4-4.062.854-.896 4.042 4.062 4-4.062.854.896-4 4.062 4 4.021-.854.896-4-4.063Z"/></svg>
          <svg xmlns="http://www.w3.org/2000/svg" class="tick" height="20" width="20"><path d="m8.229 14.438-3.896-3.917 1.438-1.438 2.458 2.459 6-6L15.667 7Z"/></svg>
      </div>
  `;
    listContainer.prepend(li);
    var http = new XMLHttpRequest();
    setFiles(prev => [...prev, file])
    var data = new FormData();
    data.append("file", file);
    http.onload = () => {
      li.classList.add("complete");
      li.classList.remove("in-prog");
      setStart(true);

    };
    http.upload.onprogress = (e) => {
      var percent_complete = (e.loaded / e.total) * 100;
      li.querySelectorAll("span")[0].innerHTML =
        Math.round(percent_complete) + "%";
      li.querySelectorAll("span")[1].style.width = percent_complete + "%";
    };
    http.open("POST", "sender.php", true);
    http.send(data);
    li.querySelector(".cross").onclick = () => http.abort();
    http.onabort = () => li.remove();
    console.log(data)
  }
  function handleFileChange(event) {
    if (event?.target?.files) {
      console.log(event?.target?.files)
      for (let eachFile of event?.target?.files) {
        if (typeValidation(eachFile.type)) {
          uploadFile(eachFile);
        }
      }

    }
  }
  function typeValidation(type) {
    if (type == "application/pdf") {
      return true;
    }
  }
  const ondragover = (e) => {
    const dropArea = document.querySelector(".drop-section");
    e.preventDefault();
    [...e.dataTransfer.items].forEach((item) => {
      if (typeValidation(item.type)) {
        dropArea.classList.add("drag-over-effect");
      }
    });
  };
  const ondragleave = () => {
    const dropArea = document.querySelector(".drop-section");
    dropArea.classList.remove("drag-over-effect");
  };

  const ondrop = (e) => {
    const dropArea = document.querySelector(".drop-section");
    e.preventDefault();
    dropArea.classList.remove("drag-over-effect");
    if (e.dataTransfer.items) {
      [...e.dataTransfer.items].forEach((item) => {
        if (item.kind === "file") {
          const file = item.getAsFile();
          if (typeValidation(file.type)) {
            uploadFile(file);
          }
        }
      });
    } else {
      [...e.dataTransfer.files].forEach((file) => {
        if (typeValidation(file.type)) {
          uploadFile(file);
        }
      });
    }
  };

  function startLoadinBar() {
    console.log("Loading.....")
    customLoadingBarRef.current.style.width = 95 + '%'

  }

  function stopLoadingBar() {
    console.log("===========Stop Loading Bar======")
    customLoadingBarRef.current.style.transition = 'width 0.5s ease-in-out'
    customLoadingBarRef.current.style.webkitTransition = 'width 0.5s ease-in-out'
    customLoadingBarRef.current.style.width = 100 + '%'
    console.log("Loading stops.....")
    heightRef.current.style.height = 'auto'
  }
  function handleCancelScreening() {
    console.log("===========Cancel clicked======")
    // controller.abort()
    // stopLoadingBar()
    // setStart(false);
    // setNotScreening(true);
    // setSuccess(false);
    // setFiles([]);
    // setExtracted(false)
   
  }

  return (
    <div style={{ marginBottom: "115px" }} ref={heightRef} className={styles.wrapperDiv}>


      {extracted ? <Jis setExtracted={setExtracted} setNotScreening={setNotScreening} setStart={setStart} /> :
        <div style={{}}>

          {notScreening ? (
            <div className="container" style={{ maxWidth: props.page === "lp" ? "1231px" : "1150px", zIndex: '1', position: 'relative' }}>
              {props.page === "lp" ? <div className={styles.DnDTitle}>{t("Experience our Resume Translations and Japanese Style Formatting")}</div> : null}

              <div className="drop-section" onDragOver={ondragover} onDrop={ondrop} onDragLeave={ondragleave}>
                <div className="col col-after-upload">
                  <div className="cloud-icon">
                    <img src={UploadIcon} alt="cloud" priority={true} />
                  </div>
                  <div>
                    <div className="titleDnD">{t("Drag and drop a Resume")}</div>
                    <div className="subTitleDnD">
                      {t("PDF file size no more than 15MB")}
                    </div>
                  </div>
                  <button className="file-selector" onClick={() => fileInputRef.current.click()}>{t("Select a file")}</button>
                  <input type="file" onChange={handleFileChange} className="file-selector-input" ref={fileInputRef} />
                </div>
                <div className="col">
                  <div className="drop-here">Drop Here</div>
                </div>
              </div>

              <div className="list-section">
                <div className="list-title">{t("Uploaded Files")}</div>
                <div className="list"></div>
              </div>

              {start ? (
                <div>
                  <button
                    className={styles.startBtn}
                    onClick={startScreening}>

                    {t("Start Converting")}
                  </button>
                </div>
              ) : <div className={styles.privacy}>
                {/* <img src={Logo} alt="logo" width={50} /> */}
                <div>

                  <p>{t("Your file will be securely handled by CosBE servers and deleted unless you sign in to save it.")}</p>

                  <Trans

                    i18nKey="myKey3"
                    defaults={t("By using this service, you agree to the <navigateLink to='/privacy-policy'>CosBE.inc's Terms of Use and Privacy Policy.</navigateLink>.")} // optional defaultValue
                    components={{ navigateLink: <Link /> }}
                  />
                </div>
              </div>}
            </div>
          ) : success ? (
            <div className={styles.loadingWrapper}>
              <div>
                <img
                  src={SuccessGif}
                  alt="Success"
                  width={200}
                  height={200}
                />
                <div className={styles.successTitle}>
                  {t("Successfully Screened!")}
                </div>
                <div className={styles.successSubTitle}>
                  {t("The resume have been uploaded successfully, and screened! The result will be shown immediately.")}
                </div>
              </div>
            </div>
          ) : (
            <div className={styles.loadingWrapperBar} style={{ visibility: 'hidden' }}>
              <div className={styles.loadingText}>
                {t("Scanning takes about 1 minute. Please wait...")}
              </div>
              <div className={styles.loadingBarWrapper} style={{ marginBottom: "15px" }}>
                <div className={styles.loadingBar}></div>
              </div>
              <button
                className={styles.startBtn}
                style={{ width: '160px', margin: '44px auto 0', cursor: "pointer" }}>
                {t("Cancel")}
              </button>
            </div>
          )
          }


          <div className={styles.loadingWrapperBar}>
            <div className={styles.loadingText}>
              {t("Scanning takes about 1 minute. Please wait...")}
            </div>
            <div className={styles.loadingBarWrapper} style={{ marginBottom: "15px" }}>
              <div className={styles.loadingBar} ref={customLoadingBarRef}></div>
            </div>
            <button
              onClick={handleCancelScreening}
              className={styles.startBtn}
              style={{ width: '160px', margin: '44px auto 0', cursor: "pointer" }}>
              {t("Cancel")}
            </button>
          </div>



        </div>
      }
    </div>
  );
}